import React from "react";
import PropTypes from "prop-types";
import { TextWrapper, Wrapper, TextWrapperSpan } from "../../../constants/common/StyledGlobalConstants";
import FormTitle from "../common/FormTitle";

const CurrentAppointmentDetails = ({ isJobScheduleDateIsWithInThreeBusinessDays, isMobile, currentAppointmentDate, currentAppointmentTimeSlot }) => {
  return (
    <>
      <FormTitle
        title="Reschedule your appointment"
        subTitle={isJobScheduleDateIsWithInThreeBusinessDays ? "" : "You can change your appointment date and time."}
      />
      <Wrapper marginTop="2rem" width="100%">
        <TextWrapper fontSize={isMobile ? "1.25rem" : "1.5rem"} fontWeight="700" lineHeight={isMobile ? "1.5rem" : "2rem"}>
          Current appointment
        </TextWrapper>
        <Wrapper marginTop="1rem" fontSize="0.875rem" fontWeight="400" border="1px solid #D8DADA" borderRadius="8px" lineHeight="1.5rem">
          <Wrapper padding="1.5rem">
            <TextWrapper fontWeight="400" fontSize="0.875rem">
              <b>Date:</b>
              <TextWrapperSpan marginLeft="0.5rem">{currentAppointmentDate}</TextWrapperSpan>
            </TextWrapper>
            <TextWrapper fontWeight="400" fontSize="0.875rem" marginTop="4px !important">
              <b>Time slot:</b>
              <TextWrapperSpan marginLeft="0.5rem">{currentAppointmentTimeSlot}</TextWrapperSpan>
            </TextWrapper>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    </>
  );
};

CurrentAppointmentDetails.propTypes = {
  isJobScheduleDateIsWithInThreeBusinessDays: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  currentAppointmentDate: PropTypes.string.isRequired,
  currentAppointmentTimeSlot: PropTypes.string.isRequired,
};

export default CurrentAppointmentDetails;
